<template>
    <div>
        <!-- <div class="common-level-rail">
            <el-button size="small" type="primary" @click="addFun">添加</el-button>
        </div> -->
        <div class="table-wrap">
            <el-table :data="listData" style="width: 100%" v-loading="loading">
                <el-table-column prop="badge_id" label="ID" width="100"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="intro" label="说明"></el-table-column>
                <el-table-column prop="badge_value" label="完成数量"></el-table-column>
                <el-table-column prop="image" label="未激活图片">
                    <template slot-scope="scope" v-if="scope.row.image">
                    <img :src="scope.row.image" width="60" height="60" />
                    </template>
                </el-table-column>
                <el-table-column prop="act_image" label="已激活图片">
                    <template slot-scope="scope" v-if="scope.row.act_image">
                    <img :src="scope.row.act_image" width="60" height="60" />
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="key_name" label="键值"></el-table-column> -->
                <el-table-column prop="status" label="状态" width="60">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="green">显示</span>
                        <span v-if="scope.row.status == 0" class="gray">隐藏</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间"></el-table-column>
                <el-table-column prop="name" label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="editFun(scope.row)" type="text" size="small">编辑</el-button>
                        <!-- <el-button @click="deleteFun(scope.row)" type="text" size="small">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!--添加-->
            <Add v-if="open_add" :open_add="open_add" @closeDialog="closeDialogFunc($event, 'add')"></Add>

            <!--编辑-->
            <Edit v-if="open_edit" :open_edit="open_edit" :form="form" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

        </div>
    </div>
</template>

<script>
    import BadgeApi from '@/api/study/badge.js';
    import Edit from './part/Edit.vue';
    import Add from './part/Add.vue';
    import {deepClone} from '@/utils/base.js';
    export default {
        components: {
            /*编辑组件*/
            Edit,
            Add
        },
        data() {
            return {
                /*分类*/
                listData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                form: {},
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                let self = this;
                let Params = {};
                BadgeApi.getList(Params, true)
                .then(data =>
                    {
                        self.loading = false;
                        self.listData = data.data.data;
                        console.log(data.data);
                    })
                    .catch(error =>
                    {
                      self.loading = false;
                    });
            },

            /*删除*/
            deleteFun(row) {
                let self = this;
                self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() =>
                {
                    self.loading = true;
                    BadgeApi.del({
                        badge_id: row.badge_id
                    }, true)
                        .then(data =>
                        {
                            self.loading = false;
                            self.$message({
                                message: data.msg,
                                type: 'success'
                            });
                            self.getTableList();

                        })
                        .catch(error =>
                        {
                            self.loading = false;
                        });

                }).catch(() =>
                {

                });
            },

            /*打开添加*/
            addFun() {
                this.open_add = true;
            },

            /*打开编辑*/
            editFun(item) {
                this.form = deepClone(item);
                this.open_edit = true;
            },

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == 'add') {
                    this.open_add = e.openDialog;
                    if (e.type == 'success') {
                        this.getTableList();
                    }
                }
                if (f == 'edit') {
                    this.open_edit = e.openDialog;
                    if (e.type == 'success') {
                        this.getTableList();
                    }
                }
            },
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/study/badge/badge/Index.vue